import { createSlice } from "@reduxjs/toolkit";
import {
  createWorkerAction,
  deleteWorkerAction,
  fetchWorkersAction,
  switchWorkerStatusAction,
  updateWorkerAction,
  changeWorkerAction,
  getUnassignedBots,
  unassignWorker,
} from "./workerThunk";

const initialState = {
  workers: [],
  isLoading: false,
  error: null,
  unAssignedBots: [],
  leads: [],
};

export const workerSlice = createSlice({
  name: "worker",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkersAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchWorkersAction.fulfilled, (state, action) => {
        state.workers = action.payload?.sort((a, b) => a.id - b.id);
        console.log("action.payload: ", action.payload);
        state.isLoading = false;
      })
      .addCase(fetchWorkersAction.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(createWorkerAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createWorkerAction.fulfilled, (state, action) => {
        state.workers.push(action.payload);
        state.isLoading = false;
      })
      .addCase(createWorkerAction.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })

      .addCase(deleteWorkerAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteWorkerAction.fulfilled, (state, action) => {
        state.workers = state.workers.filter(
          (worker) => worker.Id !== action.payload
        );
        state.isLoading = false;
      })
      .addCase(deleteWorkerAction.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(updateWorkerAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateWorkerAction.fulfilled, (state, action) => {
        state.workers = state.workers.map((worker) =>
          worker.Id === action.payload.Id ? action.payload : worker
        );
        state.isLoading = false;
      })
      .addCase(updateWorkerAction.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(switchWorkerStatusAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(switchWorkerStatusAction.fulfilled, (state, action) => {
        state.workers = state.workers.map((worker) =>
          worker.Id === action.payload.Id
            ? {
                ...worker,
                Status: worker.Status === "Active" ? "Inactive" : "Active",
              }
            : worker
        );
        state.isLoading = false;
      })
      .addCase(switchWorkerStatusAction.rejected, (state) => {
        state.isLoading = false;
      })

      // change the worker from the dropdown in the leadstable

      .addCase(changeWorkerAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changeWorkerAction.fulfilled, (state, action) => {
        state.leads = state.leads.map((lead) =>
          lead.LeadAssignmentId === action.payload.LeadAssignmentId
            ? { ...lead, Worker: action.payload.Worker }
            : lead
        );
        state.isLoading = false;
      })

      .addCase(changeWorkerAction.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getUnassignedBots.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnassignedBots.fulfilled, (state, action) => {
        state.isLoading = false;
        console.log("action.payload: ", action.payload);
        state.unAssignedBots = action.payload;
      })
      .addCase(getUnassignedBots.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(unassignWorker.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(unassignWorker.fulfilled, (state, action) => {
        // Handle successful unassigning (e.g., update workers list or unassigned bots)
        console.log("Unassigned worker response: ", action.payload);
        state.isLoading = false;
      })
      .addCase(unassignWorker.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      });
  },
});

export default workerSlice.reducer;
